<template>
  <div>
    
    <div v-if="loading" class="d-flex justify-content-center mb-3 mt-32">
      <memlist-spinner />
    </div>

    <memlist-card v-else-if="confirm_done" class="confirm-body mx-auto bg-white shadow-sm mt-16">
      <div class="row">
        <div class="col-12 text-center">
          <i class="fa fa-check-circle" style="font-size: 42px; color: #8dda8d;"></i>
        </div>
      </div>
      <div class="row" style="margin-top: 15px; border-top: 1px solid #ebedf2; padding-top: 20px;">
        <div class="col-12 text-center">
          <h4>
            {{ $t('PUBLIC.RENEW.THANKS_CONFIRM') }}
          </h4>
          <p>{{ $t('PUBLIC.RENEW.THANKS_CONFIRM_INFO') }}</p>
        </div>
      </div>
    </memlist-card>

    <div v-else>
      
      <memlist-card v-if="invalid_link" class="confirm-body mx-auto bg-white shadow-sm mt-16">
        <div>
          <memlist-inline-alert variant="danger" show>
             {{ $t('PUBLIC.RENEW.OLD_LINK') }}
          </memlist-inline-alert>
        </div>
      </memlist-card>
    
    </div>

  </div>
  
</template>

<style lang="scss" scoped>

.confirm-body {
  max-width: 640px;
}

.login-body {
  max-width: 500px;
  width: 100%;
  .login-form {
    padding: 2rem 1.5rem 2rem 1.5rem;
    .btn-login {
      font-size: 1.2rem;
      font-weight: 500;
      padding: 1rem 3rem;
      background-color: #5d78ff;
      border-color: #5d78ff;
      &:hover {
        background-color: #3758ff;
        border-color: #2a4eff;
      }
    }
  }
  .warning-message {
    padding: 30px 20px;
  }
}
</style>

<script>
import messageParent from '@/core/services/messageParent';
import { mapState } from 'vuex';

import axios from 'axios';
import dayjs from 'dayjs';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

/**
 * This is the fastest renew, simply visiting the page will confirm the membership
 */

export default {
  name: 'RenewOneclick',
  components: {
    
  },
  mixins: [ toasts ],
  data() {
    return {
      memberships: [],
      member_id: null,
      token: null,
      is_invalid: false,
      show_form: true,
      is_renew_error: false,
      form: {},
      member_renew_id: null,
      region_code: null,
      commune_code: null,
      family: [],
      renew_company_ids: [],
      me: {},
      terms: [],
      accepted: [],
      company: {},
      selected_term: {},
      invalid_link: false,
      renew: null,
      confirm_done: false,
      loading: true,
      loading_confirm: false,
      unable_confirm: false,
      renew_id: null,
    };
  },
  async mounted() {
    this.renew_id = this.$route.params.renew_id;
    this.token = this.$route.params.token;

    if (!this.renew_id || !this.token) {
      this.is_invalid = true;
      this.show_form = false;
      return;
    }

    await this.confirm_oneclick(this.renew_id, this.token);
  },
  methods: {

    onSubmit() {
      this.confirmRenew(this.renew.id, this.me.member_id, []);
    },

    term_selected(id, index, value) {

      this.terms[index].accepted = value;

      this.terms = [...this.terms];

    },
    showTerm(id) {
      this.selected_term = this.terms.find(item => item.id === id);

      this.$refs['show-term'].show();
    },

    async confirm_oneclick(member_renew_id, token) {
      this.loading_confirm = true;
      

      const res = await axios.post(`/member_renew/${member_renew_id}/oneclick/${this.token}`, {});
      
      if (res.status === 201) {
        this.loading_confirm = false;
        this.loading = false;

        this.confirm_done = true;
      }
      else {
        this.unable_confirm = true;
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('PUBLIC.RENEW.UNABLE_CONFIRM'));
      }
      
      this.loading = false;
    },
  },
  computed: {
    isContinueButtonOK() {
      const mandatories = this.terms.filter(item => item.is_mandatory);

      const num_accepted = mandatories.filter(i => i.accepted);

      if (mandatories.length !== num_accepted.length) {
        return false;
      }

      if (this.loading_confirm) {
        return false;
      }

      return true;
    },
    ...mapState({
      errors: state => state.auth.errors
    })
  }
};
</script>
